function openTab(url: string) {
  let tab = window.open(url, '_blank');
  if (tab) {
    tab.focus();
  }
}

export default openTab;


// WEBPACK FOOTER //
// ./Client/v4/Services/openTab.ts